import React, { useState, useEffect } from 'react'
import useModal from 'hook/useModal'

// css
import 'assets/style/elements/button.scss'

function Element({ text, className = '', type = 'button', size = '', color = 'default', onClick = () => {} }) {
  return (
    <>
      {(() => {
        if (type === 'more') {
          return (
            <button type="button" className={'btn btn-more ' + className} onClick={onClick}>
              더보기 +
            </button>
          )
        } else {
          return (
            <button type={type} onClick={onClick} className={`btn ${color} ${size} ` + className}>
              {text}
            </button>
          )
        }
      })()}
    </>
  )
}

export default Element
